import { createFilterOptions } from '@mui/material/useAutocomplete'
import { FeatureFlagIdActionTicketType } from 'c1gen/features'
import { Filter, onChangeFunc } from 'components/core/search-filter/filter'
import { getFilterKeyToLabelMap } from 'components/core/task/ContextualTaskSearchFilter'
import { useFeatureChecker } from 'components/no-ui/capability'
import { ActionTaskType, CertifyTaskType, GrantTaskType, RevokeTaskType, taskTypeToIntl } from 'components/pages/task/type'
import { TaskType } from 'pbts/c1/api/task/v1/task'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

type taskTypeFilterProps = {
    selected: TaskType[] | undefined
    onChange: onChangeFunc<TaskType>
    options?: TaskType[]
}

const getOptionSelected = (option1: TaskType, option2: TaskType): boolean => {
    return option1.taskType.oneofKind === option2.taskType.oneofKind
}

export const TaskTypeFilter: React.FC<taskTypeFilterProps> = ({ selected, onChange, options }): React.ReactElement => {
    const intl = useIntl()
    const filterOptions = createFilterOptions<TaskType>({})
    const isActionTicketTypeEnabled = useFeatureChecker(FeatureFlagIdActionTicketType)

    const taskTypes: TaskType[] = isActionTicketTypeEnabled
        ? [GrantTaskType, RevokeTaskType, CertifyTaskType, ActionTaskType]
        : [GrantTaskType, RevokeTaskType, CertifyTaskType]
    const filterKeyToLabel = getFilterKeyToLabelMap(intl)

    const selectedMap = selected?.map((taskType) => taskType.taskType.oneofKind) || []

    if (isActionTicketTypeEnabled) {
        if (selectedMap.length === 4 && selectedMap.includes('grant') && selectedMap.includes('revoke') && selectedMap.includes('certify') && selectedMap.includes('action')) {
            selected = []
        }
    } else if (selectedMap.length === 3 && selectedMap.includes('grant') && selectedMap.includes('revoke') && selectedMap.includes('certify')) {
        selected = []
    }

    const renderLabel = useCallback(
        (option: TaskType): string => {
            return taskTypeToIntl(option, intl)
        },
        [intl],
    )

    return (
        <Filter<TaskType>
            label={filterKeyToLabel.type || ''}
            options={options || taskTypes}
            selected={selected}
            onChange={onChange}
            filterOptions={filterOptions}
            getOptionSelected={getOptionSelected}
            renderLabel={renderLabel}
        />
    )
}
